import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    embed: PropTypes.object,
    form: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { embed, form } = this.props
    return {
      title: 't(Edit Embed)',
      method: 'PATCH',
      endpoint: `/api/admin/forms/forms/${form.id}/embeds/${embed.id}`,
      action: `/api/admin/forms/forms/${form.id}/embeds/${embed.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true  },
            { label: 't(Theme)', name: 'theme_id', type: 'dropdown', endpoint: '/api/admin/team/themes', valueKey: 'id', textKey: 'title', required: true, selectFirst: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Edit
